import React, { useState } from "react";

import {
  addDays,
  endOfMonth,
  endOfWeek,
  format,
  isBefore,
  isSameDay,
  isSameMonth,
  startOfMonth,
  startOfWeek
} from "date-fns";
import { ru } from "date-fns/locale/ru";

import {
  CalendarCell,
  CalendarGrid,
  CalendarHeader,
  CalendarTitle,
  CalendarWeekDayCell,
  CalendarWeekGrid,
  CalendarWrapper,
  NavButton,
  NavButtonNext,
  NavButtonWrapper
} from "../styles";

import { type CalendarProps } from "./types";

export const CustomCalendar: React.FC<CalendarProps> = ({ selectedDate, onChange, disabledDays }) => {
  const [currentMonth, setCurrentMonth] = useState<Date>(selectedDate || new Date());

  const today = new Date();
  const startDate = startOfWeek(startOfMonth(currentMonth), { weekStartsOn: 1 });
  const endDate = endOfWeek(endOfMonth(currentMonth), { weekStartsOn: 1 });

  const handlePrevMonth = () => setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  const handleNextMonth = () => setCurrentMonth(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));

  const WEEKDAYS = ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"];

  const renderWeekDays = () => {
    return WEEKDAYS.map((day, i) => (
      <CalendarWeekDayCell key={i}>
        {day}
      </CalendarWeekDayCell>
    ));
  };

  const renderCells = () => {
    const days = [];
    let day = startDate;

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        const dayClone = day;
        const isWeekend = day.getDay() === 0 || day.getDay() === 6;
        const isPastOrToday = isBefore(day, today) || isSameDay(day, today);

        const isInDisabledList = disabledDays.some((d) => isSameDay(d, day));
        const isDisabled = isWeekend || isPastOrToday || isInDisabledList;
        const isSelected = selectedDate ? isSameDay(day, selectedDate) : false;
        const isOutside = !isSameMonth(day, currentMonth);

        days.push(
          <CalendarCell
            key={day.toISOString()}
            isDisabled={isDisabled}
            isOutsideCurrentMonth={isOutside}
            selected={isSelected}
            onClick={() => {
              if (!isDisabled) onChange(dayClone);
            }}
          >
            <span>{format(day, "d")}</span>
          </CalendarCell>
        );
        day = addDays(day, 1);
      }
    }

    return days;
  };

  return (
    <CalendarWrapper>
      <CalendarHeader>
        <NavButtonWrapper onClick={handlePrevMonth}>
          <NavButton />
        </NavButtonWrapper>
        <CalendarTitle>
          {format(currentMonth, "LLLL yyyy", { locale: ru })}
        </CalendarTitle>
        <NavButtonWrapper onClick={handleNextMonth}>
          <NavButtonNext />
        </NavButtonWrapper>
      </CalendarHeader>
      <CalendarWeekGrid>{renderWeekDays()}</CalendarWeekGrid>
      <CalendarGrid>{renderCells()}</CalendarGrid>
    </CalendarWrapper>
  );
};
